import Service from "../../AuthService";
const FactorialMaterialExport = {
    getFactorialMaterialExport(page) {
        return Service.get("/factorial-material-export?page="+page);
    },
    showFactorialMaterialExport(id) {
        return Service.get("/factorial-material-export/" + id);
    },
    updateFactorialMaterialExport(id, data) {
        return Service.put("/factorial-material-export/" + id, data);
    },
    createFactorialMaterialExport(data) {
        return Service.post("/factorial-material-export", data);
    },
    deleteFactorialMaterialExport(id) {
        return Service.delete("/factorial-material-export/" + id);
    },
    searchFactorialMaterialExport(data){
        return Service.post('/search-factorial-material-export',data);
    },
};
export default FactorialMaterialExport;
